import { reactive } from 'vue'

// Palettes × light/dark, ported from the Samui design bundle (oklch).
// `getphuket` is the public brand palette (see docs/brand/) — also the default
// for the public site, applied via :root[data-surface="public"] in application.css.
export const PALETTES = {
  getphuket: {
    name: 'Get Phuket',
    light: {
      bg: 'oklch(0.974 0.016 59)',       // Sand
      surface: 'oklch(1 0 0)',           // Paper
      surfaceAlt: 'oklch(0.955 0.02 59)',
      ink: 'oklch(0.205 0.037 264)',     // Ink
      inkSoft: 'oklch(0.372 0.039 257)', // Ink Soft
      muted: 'oklch(0.60 0.03 257)',     // Muted
      line: 'oklch(0.935 0.007 248)',    // Line
      lineStrong: 'oklch(0.86 0.012 252)',
      accent: 'oklch(0.685 0.206 32.5)', // Sunset
      accentInk: 'oklch(0.99 0.01 60)',
      accentSoft: 'oklch(0.93 0.05 36)',
      second: 'oklch(0.715 0.126 215)',  // Lagoon
      secondSoft: 'oklch(0.93 0.04 215)',
      ok: 'oklch(0.64 0.14 150)',
      okSoft: 'oklch(0.93 0.05 150)',
      warn: 'oklch(0.77 0.15 70)',
      warnSoft: 'oklch(0.95 0.06 75)',
      danger: 'oklch(0.57 0.20 25)',
      dangerSoft: 'oklch(0.94 0.05 25)',
      info: 'oklch(0.66 0.11 220)',
      infoSoft: 'oklch(0.93 0.04 220)',
    },
    dark: {
      bg: 'oklch(0.189 0.037 264)',      // Ink (night base)
      surface: 'oklch(0.23 0.035 263)',
      surfaceAlt: 'oklch(0.27 0.035 262)',
      ink: 'oklch(0.97 0.012 70)',
      inkSoft: 'oklch(0.80 0.015 250)',
      muted: 'oklch(0.64 0.03 255)',
      line: 'oklch(0.32 0.03 260)',
      lineStrong: 'oklch(0.40 0.03 260)',
      accent: 'oklch(0.70 0.19 33)',     // Sunset (lifted for dark)
      accentInk: 'oklch(0.19 0.03 264)',
      accentSoft: 'oklch(0.34 0.10 33)',
      second: 'oklch(0.76 0.12 212)',    // Lagoon
      secondSoft: 'oklch(0.32 0.07 212)',
      ok: 'oklch(0.72 0.13 150)',
      okSoft: 'oklch(0.30 0.07 150)',
      warn: 'oklch(0.82 0.14 75)',
      warnSoft: 'oklch(0.34 0.08 75)',
      danger: 'oklch(0.70 0.18 25)',
      dangerSoft: 'oklch(0.32 0.09 25)',
      info: 'oklch(0.74 0.11 220)',
      infoSoft: 'oklch(0.30 0.06 220)',
    },
  },
  sunset: {
    name: 'Sunset Coast',
    light: {
      bg: 'oklch(0.985 0.012 75)',
      surface: 'oklch(0.995 0.008 75)',
      surfaceAlt: 'oklch(0.96 0.015 75)',
      ink: 'oklch(0.22 0.035 200)',
      inkSoft: 'oklch(0.42 0.03 200)',
      muted: 'oklch(0.62 0.02 200)',
      line: 'oklch(0.90 0.015 75)',
      lineStrong: 'oklch(0.82 0.02 75)',
      accent: 'oklch(0.62 0.15 40)',
      accentInk: 'oklch(0.98 0.012 75)',
      accentSoft: 'oklch(0.92 0.04 40)',
      second: 'oklch(0.58 0.09 175)',
      secondSoft: 'oklch(0.92 0.03 175)',
      ok: 'oklch(0.62 0.11 155)',
      okSoft: 'oklch(0.93 0.04 155)',
      warn: 'oklch(0.72 0.13 75)',
      warnSoft: 'oklch(0.95 0.05 75)',
      danger: 'oklch(0.58 0.16 25)',
      dangerSoft: 'oklch(0.94 0.04 25)',
      info: 'oklch(0.58 0.09 175)',
      infoSoft: 'oklch(0.93 0.03 175)',
    },
    dark: {
      bg: 'oklch(0.17 0.018 220)',
      surface: 'oklch(0.21 0.02 220)',
      surfaceAlt: 'oklch(0.25 0.022 220)',
      ink: 'oklch(0.97 0.012 75)',
      inkSoft: 'oklch(0.82 0.012 75)',
      muted: 'oklch(0.62 0.02 220)',
      line: 'oklch(0.30 0.022 220)',
      lineStrong: 'oklch(0.38 0.025 220)',
      accent: 'oklch(0.70 0.14 45)',
      accentInk: 'oklch(0.15 0.02 220)',
      accentSoft: 'oklch(0.32 0.08 40)',
      second: 'oklch(0.72 0.09 175)',
      secondSoft: 'oklch(0.30 0.05 175)',
      ok: 'oklch(0.72 0.11 155)',
      okSoft: 'oklch(0.30 0.06 155)',
      warn: 'oklch(0.80 0.13 75)',
      warnSoft: 'oklch(0.32 0.08 75)',
      danger: 'oklch(0.72 0.14 25)',
      dangerSoft: 'oklch(0.30 0.08 25)',
      info: 'oklch(0.72 0.09 175)',
      infoSoft: 'oklch(0.30 0.05 175)',
    },
  },
  monsoon: {
    name: 'Monsoon Indigo',
    light: {
      bg: 'oklch(0.975 0.008 80)',
      surface: 'oklch(1.0 0 0)',
      surfaceAlt: 'oklch(0.955 0.01 80)',
      ink: 'oklch(0.22 0.05 260)',
      inkSoft: 'oklch(0.42 0.04 260)',
      muted: 'oklch(0.58 0.025 260)',
      line: 'oklch(0.90 0.012 260)',
      lineStrong: 'oklch(0.82 0.018 260)',
      accent: 'oklch(0.72 0.13 75)',
      accentInk: 'oklch(0.20 0.04 260)',
      accentSoft: 'oklch(0.94 0.05 75)',
      second: 'oklch(0.55 0.10 160)',
      secondSoft: 'oklch(0.93 0.04 160)',
      ok: 'oklch(0.62 0.12 150)',
      okSoft: 'oklch(0.94 0.04 150)',
      warn: 'oklch(0.72 0.13 75)',
      warnSoft: 'oklch(0.95 0.05 75)',
      danger: 'oklch(0.58 0.18 20)',
      dangerSoft: 'oklch(0.94 0.04 20)',
      info: 'oklch(0.58 0.12 255)',
      infoSoft: 'oklch(0.94 0.03 255)',
    },
    dark: {
      bg: 'oklch(0.16 0.025 260)',
      surface: 'oklch(0.20 0.028 260)',
      surfaceAlt: 'oklch(0.24 0.03 260)',
      ink: 'oklch(0.97 0.008 80)',
      inkSoft: 'oklch(0.82 0.012 80)',
      muted: 'oklch(0.60 0.03 260)',
      line: 'oklch(0.30 0.028 260)',
      lineStrong: 'oklch(0.38 0.03 260)',
      accent: 'oklch(0.78 0.13 80)',
      accentInk: 'oklch(0.16 0.025 260)',
      accentSoft: 'oklch(0.32 0.08 75)',
      second: 'oklch(0.70 0.10 160)',
      secondSoft: 'oklch(0.30 0.06 160)',
      ok: 'oklch(0.72 0.12 150)',
      okSoft: 'oklch(0.30 0.06 150)',
      warn: 'oklch(0.80 0.13 75)',
      warnSoft: 'oklch(0.32 0.08 75)',
      danger: 'oklch(0.72 0.16 20)',
      dangerSoft: 'oklch(0.32 0.09 20)',
      info: 'oklch(0.72 0.12 255)',
      infoSoft: 'oklch(0.30 0.06 255)',
    },
  },
  navy: {
    name: 'Classic Navy',
    light: {
      bg: 'oklch(0.975 0.010 255)',
      surface: 'oklch(0.995 0.005 255)',
      surfaceAlt: 'oklch(0.955 0.014 255)',
      ink: 'oklch(0.22 0.035 255)',
      inkSoft: 'oklch(0.42 0.03 255)',
      muted: 'oklch(0.58 0.02 255)',
      line: 'oklch(0.90 0.014 255)',
      lineStrong: 'oklch(0.82 0.02 255)',
      accent: 'oklch(0.42 0.14 260)',
      accentInk: 'oklch(0.98 0.005 255)',
      accentSoft: 'oklch(0.93 0.04 260)',
      second: 'oklch(0.58 0.09 200)',
      secondSoft: 'oklch(0.93 0.03 200)',
      ok: 'oklch(0.60 0.11 150)',
      okSoft: 'oklch(0.93 0.04 150)',
      warn: 'oklch(0.72 0.13 75)',
      warnSoft: 'oklch(0.95 0.05 75)',
      danger: 'oklch(0.58 0.16 25)',
      dangerSoft: 'oklch(0.94 0.04 25)',
      info: 'oklch(0.58 0.12 255)',
      infoSoft: 'oklch(0.94 0.03 255)',
    },
    dark: {
      bg: 'oklch(0.16 0.02 255)',
      surface: 'oklch(0.20 0.022 255)',
      surfaceAlt: 'oklch(0.24 0.024 255)',
      ink: 'oklch(0.97 0.008 255)',
      inkSoft: 'oklch(0.82 0.01 255)',
      muted: 'oklch(0.60 0.025 255)',
      line: 'oklch(0.30 0.024 255)',
      lineStrong: 'oklch(0.38 0.026 255)',
      accent: 'oklch(0.68 0.13 260)',
      accentInk: 'oklch(0.14 0.02 255)',
      accentSoft: 'oklch(0.30 0.08 260)',
      second: 'oklch(0.70 0.09 200)',
      secondSoft: 'oklch(0.30 0.05 200)',
      ok: 'oklch(0.70 0.11 150)',
      okSoft: 'oklch(0.30 0.06 150)',
      warn: 'oklch(0.80 0.13 75)',
      warnSoft: 'oklch(0.32 0.08 75)',
      danger: 'oklch(0.72 0.14 25)',
      dangerSoft: 'oklch(0.30 0.08 25)',
      info: 'oklch(0.72 0.12 255)',
      infoSoft: 'oklch(0.30 0.06 255)',
    },
  },
  forest: {
    name: 'Forest Green',
    light: {
      bg: 'oklch(0.975 0.012 150)',
      surface: 'oklch(0.995 0.006 150)',
      surfaceAlt: 'oklch(0.955 0.016 150)',
      ink: 'oklch(0.22 0.03 150)',
      inkSoft: 'oklch(0.42 0.025 150)',
      muted: 'oklch(0.58 0.02 150)',
      line: 'oklch(0.90 0.014 150)',
      lineStrong: 'oklch(0.82 0.02 150)',
      accent: 'oklch(0.45 0.09 150)',
      accentInk: 'oklch(0.98 0.006 150)',
      accentSoft: 'oklch(0.93 0.04 150)',
      second: 'oklch(0.58 0.09 75)',
      secondSoft: 'oklch(0.93 0.03 75)',
      ok: 'oklch(0.60 0.11 150)',
      okSoft: 'oklch(0.93 0.04 150)',
      warn: 'oklch(0.72 0.13 75)',
      warnSoft: 'oklch(0.95 0.05 75)',
      danger: 'oklch(0.58 0.16 25)',
      dangerSoft: 'oklch(0.94 0.04 25)',
      info: 'oklch(0.58 0.10 230)',
      infoSoft: 'oklch(0.93 0.03 230)',
    },
    dark: {
      bg: 'oklch(0.16 0.02 150)',
      surface: 'oklch(0.20 0.022 150)',
      surfaceAlt: 'oklch(0.24 0.024 150)',
      ink: 'oklch(0.97 0.008 150)',
      inkSoft: 'oklch(0.82 0.01 150)',
      muted: 'oklch(0.60 0.025 150)',
      line: 'oklch(0.30 0.024 150)',
      lineStrong: 'oklch(0.38 0.026 150)',
      accent: 'oklch(0.66 0.10 150)',
      accentInk: 'oklch(0.14 0.02 150)',
      accentSoft: 'oklch(0.30 0.06 150)',
      second: 'oklch(0.70 0.09 75)',
      secondSoft: 'oklch(0.30 0.05 75)',
      ok: 'oklch(0.70 0.11 150)',
      okSoft: 'oklch(0.30 0.06 150)',
      warn: 'oklch(0.80 0.13 75)',
      warnSoft: 'oklch(0.32 0.08 75)',
      danger: 'oklch(0.72 0.14 25)',
      dangerSoft: 'oklch(0.30 0.08 25)',
      info: 'oklch(0.72 0.10 230)',
      infoSoft: 'oklch(0.30 0.05 230)',
    },
  },
  graphite: {
    name: 'Graphite',
    light: {
      bg: 'oklch(0.975 0.003 260)',
      surface: 'oklch(0.995 0.002 260)',
      surfaceAlt: 'oklch(0.95 0.004 260)',
      ink: 'oklch(0.18 0.01 260)',
      inkSoft: 'oklch(0.38 0.008 260)',
      muted: 'oklch(0.58 0.006 260)',
      line: 'oklch(0.88 0.004 260)',
      lineStrong: 'oklch(0.80 0.006 260)',
      accent: 'oklch(0.30 0.02 260)',
      accentInk: 'oklch(0.98 0.002 260)',
      accentSoft: 'oklch(0.90 0.006 260)',
      second: 'oklch(0.50 0.01 260)',
      secondSoft: 'oklch(0.92 0.004 260)',
      ok: 'oklch(0.55 0.10 150)',
      okSoft: 'oklch(0.93 0.04 150)',
      warn: 'oklch(0.70 0.12 75)',
      warnSoft: 'oklch(0.95 0.05 75)',
      danger: 'oklch(0.55 0.15 25)',
      dangerSoft: 'oklch(0.94 0.04 25)',
      info: 'oklch(0.55 0.10 240)',
      infoSoft: 'oklch(0.93 0.03 240)',
    },
    dark: {
      bg: 'oklch(0.15 0.004 260)',
      surface: 'oklch(0.19 0.005 260)',
      surfaceAlt: 'oklch(0.23 0.006 260)',
      ink: 'oklch(0.97 0.003 260)',
      inkSoft: 'oklch(0.82 0.005 260)',
      muted: 'oklch(0.60 0.006 260)',
      line: 'oklch(0.30 0.006 260)',
      lineStrong: 'oklch(0.38 0.008 260)',
      accent: 'oklch(0.82 0.01 260)',
      accentInk: 'oklch(0.14 0.004 260)',
      accentSoft: 'oklch(0.32 0.008 260)',
      second: 'oklch(0.70 0.008 260)',
      secondSoft: 'oklch(0.30 0.006 260)',
      ok: 'oklch(0.70 0.11 150)',
      okSoft: 'oklch(0.30 0.06 150)',
      warn: 'oklch(0.80 0.13 75)',
      warnSoft: 'oklch(0.32 0.08 75)',
      danger: 'oklch(0.72 0.14 25)',
      dangerSoft: 'oklch(0.30 0.08 25)',
      info: 'oklch(0.72 0.10 240)',
      infoSoft: 'oklch(0.30 0.05 240)',
    },
  },
}

export const FONT_PAIRS = {
  sora: {
    label: 'Get Phuket',
    display: "'Sora', ui-sans-serif, system-ui, sans-serif",
    body:    "'Inter', ui-sans-serif, system-ui, sans-serif",
    mono:    "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
  },
  system: {
    label: 'System',
    display: "'Inter', ui-sans-serif, system-ui, sans-serif",
    body:    "'Inter', ui-sans-serif, system-ui, sans-serif",
    mono:    "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
  },
  reader: {
    label: 'Reader',
    display: "'Merriweather', Georgia, serif",
    body:    "'Inter', ui-sans-serif, system-ui, sans-serif",
    mono:    "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
  },
  friendly: {
    label: 'Friendly',
    display: "'Poppins', ui-sans-serif, system-ui, sans-serif",
    body:    "'Poppins', ui-sans-serif, system-ui, sans-serif",
    mono:    "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
  },
  soft: {
    label: 'Soft',
    display: "'Nunito', ui-sans-serif, system-ui, sans-serif",
    body:    "'Open Sans', ui-sans-serif, system-ui, sans-serif",
    mono:    "'DM Mono', ui-monospace, SFMono-Regular, monospace",
  },
  workhorse: {
    label: 'Workhorse',
    display: "'DM Sans', ui-sans-serif, system-ui, sans-serif",
    body:    "'DM Sans', ui-sans-serif, system-ui, sans-serif",
    mono:    "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
  },
  compact: {
    label: 'Compact',
    display: "'Source Sans 3', ui-sans-serif, system-ui, sans-serif",
    body:    "'Source Sans 3', ui-sans-serif, system-ui, sans-serif",
    mono:    "'Source Code Pro', ui-monospace, SFMono-Regular, monospace",
  },
}

// Background tints — override bg + surface + surfaceAlt on top of the palette.
// `auto` means "don't override, use the palette's own values".
export const BG_TINTS = {
  auto:     { label: 'Auto',     swatch: { light: 'oklch(0.985 0.012 75)',  dark: 'oklch(0.17 0.018 220)' } },
  sand:     { label: 'Sand',     light: { bg: 'oklch(0.965 0.022 80)',  surface: 'oklch(0.99 0.012 80)',  surfaceAlt: 'oklch(0.94 0.025 80)' },
                                  dark:  { bg: 'oklch(0.19 0.018 70)',  surface: 'oklch(0.23 0.02 70)',   surfaceAlt: 'oklch(0.27 0.022 70)' } },
  slate:    { label: 'Slate',    light: { bg: 'oklch(0.96 0.008 230)',  surface: 'oklch(0.99 0.006 230)', surfaceAlt: 'oklch(0.93 0.01 230)' },
                                  dark:  { bg: 'oklch(0.18 0.016 240)', surface: 'oklch(0.22 0.018 240)', surfaceAlt: 'oklch(0.26 0.02 240)' } },
  midnight: { label: 'Midnight', light: { bg: 'oklch(0.955 0.02 260)',  surface: 'oklch(0.99 0.012 260)', surfaceAlt: 'oklch(0.92 0.025 260)' },
                                  dark:  { bg: 'oklch(0.15 0.03 265)',  surface: 'oklch(0.19 0.032 265)', surfaceAlt: 'oklch(0.23 0.034 265)' } },
  forest:   { label: 'Forest',   light: { bg: 'oklch(0.96 0.018 155)',  surface: 'oklch(0.99 0.01 155)',  surfaceAlt: 'oklch(0.93 0.022 155)' },
                                  dark:  { bg: 'oklch(0.17 0.025 160)', surface: 'oklch(0.21 0.028 160)', surfaceAlt: 'oklch(0.25 0.03 160)' } },
  rust:     { label: 'Rust',     light: { bg: 'oklch(0.955 0.028 45)',  surface: 'oklch(0.99 0.015 45)',  surfaceAlt: 'oklch(0.925 0.035 45)' },
                                  dark:  { bg: 'oklch(0.18 0.035 45)',  surface: 'oklch(0.22 0.038 45)',  surfaceAlt: 'oklch(0.26 0.04 45)' } },
}

export const SIZES = {
  small:  { label: 'Small',  px: '14px' },
  medium: { label: 'Medium', px: '16px' },
  large:  { label: 'Large',  px: '18px' },
}

export const BUTTON_RADII = {
  sharp:  { label: 'Sharp',  value: '4px' },
  soft:   { label: 'Soft',   value: '10px' },
  pill:   { label: 'Pill',   value: '9999px' },
}

export const INPUT_RADII = {
  sharp:  { label: 'Sharp',  value: '4px' },
  soft:   { label: 'Soft',   value: '10px' },
  pill:   { label: 'Pill',   value: '9999px' },
}

export const TABLE_RADII = {
  sharp:  { label: 'Sharp',  value: '0px' },
  soft:   { label: 'Soft',   value: '10px' },
  round:  { label: 'Round',  value: '16px' },
}

// Weight applied to money/metric values across the app (money totals, stat
// card values, table numeric columns). Labels and headings keep their own
// weights — this knob only touches text that uses `font-[var(--weight-value)]`.
export const VALUE_WEIGHTS = {
  regular:  { label: 'Regular',  value: '400' },
  medium:   { label: 'Medium',   value: '500' },
  semibold: { label: 'Semibold', value: '600' },
}

const DEFAULTS = {
  palette: 'sunset',
  mode: 'light',
  sidebar: 'full',       // full | rail | hidden
  fontPair: 'system',
  bgTint: 'auto',        // auto | sand | slate | midnight | forest | rust
  fontSize: 'medium',    // small | medium | large
  buttonRadius: 'soft',  // sharp | soft | pill
  inputRadius:  'soft',  // sharp | soft | pill
  tableRadius:  'soft',  // sharp | soft | round
  valueWeight:  'medium', // regular | medium | semibold
}

const STORE_KEY = 'samui_tweaks_v1'

// Single global reactive instance — shared across any component that imports useTweaks().
const state = reactive({ ...DEFAULTS })

function readStored() {
  if (typeof localStorage === 'undefined') return {}
  try {
    const raw = localStorage.getItem(STORE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch { return {} }
}

// Apply current state → :root CSS vars
function applyTokens() {
  if (typeof document === 'undefined') return
  const p = PALETTES[state.palette]?.[state.mode] || PALETTES.sunset.light
  const r = document.documentElement
  for (const [k, v] of Object.entries(p)) r.style.setProperty(`--${k}`, v)

  // Background tint override — retargets bg/surface/surfaceAlt on top of palette.
  const tint = BG_TINTS[state.bgTint]
  if (tint && state.bgTint !== 'auto') {
    const vars = tint[state.mode]
    if (vars) for (const [k, v] of Object.entries(vars)) r.style.setProperty(`--${k}`, v)
  }

  const fonts = FONT_PAIRS[state.fontPair] || FONT_PAIRS.system
  r.style.setProperty('--display', fonts.display)
  r.style.setProperty('--body', fonts.body)
  r.style.setProperty('--mono', fonts.mono)
  // Also mirror onto Tailwind-owned font tokens — the `@theme` values are baked
  // at build time, so we must overwrite them at runtime for `font-sans`,
  // `font-body`, `font-display`, `font-mono` Tailwind utilities to track.
  r.style.setProperty('--font-display', fonts.display)
  r.style.setProperty('--font-body',    fonts.body)
  r.style.setProperty('--font-sans',    fonts.body)
  r.style.setProperty('--font-mono',    fonts.mono)

  r.dataset.palette  = state.palette
  r.dataset.mode     = state.mode
  r.dataset.fontPair = state.fontPair
  r.dataset.bgTint   = state.bgTint
  r.style.colorScheme = state.mode

  const size = SIZES[state.fontSize] || SIZES.medium
  r.style.setProperty('--font-size-base', size.px)
  r.dataset.fontSize = state.fontSize

  const btn  = BUTTON_RADII[state.buttonRadius] || BUTTON_RADII.soft
  const inp  = INPUT_RADII[state.inputRadius]   || INPUT_RADII.soft
  const tbl  = TABLE_RADII[state.tableRadius]   || TABLE_RADII.soft
  r.style.setProperty('--radius-button', btn.value)
  r.style.setProperty('--radius-input',  inp.value)
  r.style.setProperty('--radius-table',  tbl.value)
  r.dataset.buttonRadius = state.buttonRadius
  r.dataset.inputRadius  = state.inputRadius
  r.dataset.tableRadius  = state.tableRadius

  const vw = VALUE_WEIGHTS[state.valueWeight] || VALUE_WEIGHTS.medium
  r.style.setProperty('--weight-value', vw.value)
  r.dataset.valueWeight = state.valueWeight
}

function persist() {
  try { localStorage.setItem(STORE_KEY, JSON.stringify(state)) } catch {}
}

function commit() {
  persist()
  applyTokens()
}

let initialised = false
function init() {
  if (initialised) return
  initialised = true
  Object.assign(state, { ...DEFAULTS, ...readStored() })
  if (!PALETTES[state.palette])              state.palette      = DEFAULTS.palette
  if (!BG_TINTS[state.bgTint])               state.bgTint       = DEFAULTS.bgTint
  if (!FONT_PAIRS[state.fontPair])           state.fontPair     = DEFAULTS.fontPair
  if (!SIZES[state.fontSize])                state.fontSize     = DEFAULTS.fontSize
  if (!BUTTON_RADII[state.buttonRadius])     state.buttonRadius = DEFAULTS.buttonRadius
  if (!INPUT_RADII[state.inputRadius])       state.inputRadius  = DEFAULTS.inputRadius
  if (!TABLE_RADII[state.tableRadius])       state.tableRadius  = DEFAULTS.tableRadius
  if (!VALUE_WEIGHTS[state.valueWeight])     state.valueWeight  = DEFAULTS.valueWeight
  applyTokens()
}

export function useTweaks() {
  init()
  return {
    tweaks: state,
    setTweak(key, value) {
      state[key] = value
      commit()
    },
    cycleSidebar() {
      const order = ['full', 'rail', 'hidden']
      const i = order.indexOf(state.sidebar)
      state.sidebar = order[(i + 1) % order.length]
      commit()
    },
    toggleMode() {
      state.mode = state.mode === 'light' ? 'dark' : 'light'
      commit()
    },
    reset() {
      Object.assign(state, DEFAULTS)
      commit()
    },
  }
}
